import { render, staticRenderFns } from "./announcementView.vue?vue&type=template&id=56fbc928&scoped=true"
import script from "./announcementView.vue?vue&type=script&lang=js"
export * from "./announcementView.vue?vue&type=script&lang=js"
import style0 from "./announcementView.vue?vue&type=style&index=0&id=56fbc928&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fbc928",
  null
  
)

export default component.exports